import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/customerDetails.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DetailsIbutton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      serialNo: "",
      name: "",
      statee: "",
      lastevent: "",
      assetName: "",
      deviceName: "",
      lastDisconnect: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profileId: "",
      profileName: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: "",
      statusName: "",
      id: "",
      created: "",
      updated: "",
    };
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/IButton/SelectIButton/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setData(response.data[0]);
      if (response.status == "200") {
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`)

      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setData = (data) => {
    const {
      name,
      tag1,
      tag2,
      lastDisconnect,
      notes,
      profile,
      state,
      deviceName,
      lastConnect,
      assetName,
      lastevent,
      status,
      serialNo,
      icon,
      description,
      customerName,
      colour,
      adminNotes,
      id,
      dbCreated,
      dbUpdated,
    } = data;
    this.setState({
      name,
      tag1,
      tag2,
      lastDisconnect,
      description,
      color: colour,
      assetName,
      lastConnect,
      deviceName,
      icon,
      lastevent,
      notes,
      statee: state,
      serialNo,
      adminNotes,
      customerName,
      profileName: profile,
      statusName: status,
      id,
      created: dbCreated,
      updated: dbUpdated,
    });
  };

  handleOk = () => {
    this.props.history.push("/ibutton");
  };

  handleEdit = () => {
    this.props.history.push(`/editIbutton/${this.state.id}`);
  };

  render() {
    const {
      name,
      statee,
      deviceName,
      lastDisconnect,
      lastConnect,
      assetName,
      lastevent,
      serialNo,
      statusName,
      customerName,
      created,
      updated,
    } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Details iButton </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h1 style={{ padding: 0, margin: 0 }}>Details iButton</h1>
              <span className="underlineText">{name}</span>
              <hr />
              <Form>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Customer
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{customerName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Serial No
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{serialNo}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Name
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{name}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      State
                    </p>
                  </Col>
                  <Col sm="10">
                    <p
                      className="detailsValue"
                      style={
                        statee == "Disconnected"
                          ? { color: "red" }
                          : { color: "green" }
                      }
                    >
                      {statee}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Last Event
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToLocal(lastevent)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Asset
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{assetName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Device
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{deviceName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Last Connect
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToLocal(lastConnect)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Last Disconnect
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToLocal(lastDisconnect)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Status
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{statusName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Created
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToLocal(created)}</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <p className="detailsLabel" style={{ float: "right" }}>
                      Updated
                    </p>
                  </Col>
                  <Col sm="10">
                    <p className="detailsValue">{utcToLocal(updated)}</p>
                  </Col>
                </Row>

                <Row>
                  <Col sm="2"></Col>
                  <Col sm="10"></Col>
                </Row>
              </Form>
              <br />
              <div className="footer-menu">
                <Button variant="outline-secondary" onClick={this.handleOk}>
                  Back to List
                </Button>
                &nbsp;
                <Button variant="primary" onClick={this.handleEdit}>
                  Edit
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsIbutton);
